import { createContext, useContext, useEffect, useState } from "react";
import { userApi, USER_TOKEN_KEY } from "@/user/api";

const Ctx = createContext(null);

export function UserAuthProvider({ children }) {
    const [state, setState] = useState({ user: null, company: null });
    const [status, setStatus] = useState("loading"); // loading | guest | ready

    useEffect(() => {
        const t = localStorage.getItem(USER_TOKEN_KEY);
        if (!t) {
            setStatus("guest");
            return;
        }
        userApi
            .get("/user/me")
            .then((r) => {
                setState({ user: r.data.user, company: r.data.company });
                setStatus("ready");
            })
            .catch(() => {
                localStorage.removeItem(USER_TOKEN_KEY);
                setStatus("guest");
            });
    }, []);

    async function login(email, password) {
        const { data } = await userApi.post("/user/login", { email, password });
        localStorage.setItem(USER_TOKEN_KEY, data.token);
        setState({ user: data.user, company: data.company });
        setStatus("ready");
        return data;
    }

    async function logout() {
        try {
            await userApi.post("/user/logout");
        } catch (_e) {
            /* ignore */
        }
        localStorage.removeItem(USER_TOKEN_KEY);
        setState({ user: null, company: null });
        setStatus("guest");
    }

    async function refresh() {
        try {
            const { data } = await userApi.get("/user/me");
            setState({ user: data.user, company: data.company });
        } catch (_e) {
            /* ignore */
        }
    }

    return (
        <Ctx.Provider value={{ ...state, status, login, logout, refresh }}>
            {children}
        </Ctx.Provider>
    );
}

export function useUserAuth() {
    const v = useContext(Ctx);
    if (!v) throw new Error("useUserAuth must be used within UserAuthProvider");
    return v;
}
